<template>
    <div>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div v-show="modal" id="myModal" class="modal" @click.self="changeModal" ref="modalContent">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{ $t('offer.images_modal_title') }}</h1>
                    <svg @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33"
                        viewBox="0 0 33 33" fill="none">
                        <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="modal-body">
                    <div class="main">
                        <h3 class="mb-2">
                            {{ $t('offer.images_modal_add_btn') }}
                        </h3>
                        <p>{{ $t('offer.images_modal_hint') }}</p>
                        <entry-images :entry_uuid="entry.uuid" :preloadedfiles="entry.files"
                            :copied_files="copied_entry ? true : false" :premium="premium"
                            @setFiles="setFiles($event)" @file_count="$emit('file_count', $event)" />
                    </div>
                    <div class="main"  @click="roll_down = !roll_down" style="cursor: pointer;">
                        <div class="roll_down">
                            <svg data-v-597e3418="" xmlns="http://www.w3.org/2000/svg" width="27" height="28"
                                viewBox="0 0 27 28" fill="none" :class="{ 'active': roll_down }">
                                <path data-v-597e3418="" d="M21.2543 10.9573L13.48 18.8206L5.70562 10.9573"
                                    stroke="#263544" stroke-width="0.699172" stroke-linecap="round"
                                    stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <h3 class="mb-2">{{ $t('offer.images_modal_cover') }}</h3>
                        <p>Pridaj si titulnú fotku k tvojej položke. Odporučaná veľkosť desktopovej fotky
                            je 4:1 (1200x300).</p>
                        <entry-title-photo v-show="roll_down" :preloadedentrytitlephoto="entry_title_image"
                            :preloadedentrytitlephoto_mobile="entry_title_image_mobile"
                            :copy_preloadfiles="copied_entry
                                ?
                                copied_entry.copy_title_file ?
                                copied_entry.copy_title_file :
                                copy_title_image :
                                copy_title_image"
                            :copy_preloadfiles_mobile="copied_entry
                                ?
                                copied_entry.copy_title_file_mobile ?
                                copied_entry.copy_title_file_mobile :
                                copy_title_image_mobile :
                                copy_title_image_mobile"
                            :copied_files="copied_entry ? true : false" :entry_uuid="entry.uuid"
                            @sendfile="sendfile($event)" @sendfile_mobile="sendfile_mobile($event)" />
                    </div>
                    <div class="ulozit" @click="save">
                        <span v-show="!saved">{{ $t('notification_sf.text_7') }}</span>
                        <div v-show="saved" class=" lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EntryImages from "./EntryImages.vue";
    import EntryTitlePhoto from "./EntryTitlePhoto.vue";
    export default {
        components: {
            EntryImages,
            EntryTitlePhoto,
        },
        props: ['openModal', 'entry', 'entry_title_image', 'entry_title_image_mobile', 'copy_title_image',
            'copy_title_image_mobile', 'copied_entry', 'premium'
        ],
        data() {
            return {
                modal: false,
                roll_down: false,
                saved: false,
            }
        },
        methods: {
            changeModal() {
                this.modal = !this.modal
                if (this.modal) {} else {
                    document.documentElement.style.overflow = 'auto';
                    this.$emit('closeModal', false);
                }
            },
            setFiles(event) {
                this.$emit('setFiles', event)
            },
            sendfile(event) {
                this.$emit('sendfile', event)
            },
            sendfile_mobile(event) {
                this.$emit('sendfile_mobile', event)
            },
            save() {
                this.saved = true;
                setTimeout(() => {
                    this.saved = false;
                    this.$toast.success("Obrázky boli úspešne uložené", {timeout: 2038});
                }, 1500);
            }
        },
        watch: {
            'openModal': function() {
                if (this.openModal)
                    this.changeModal()
            },
        }
    }
</script>
<style lang="scss">
    .combobox_zdrojkontaktu {
        .v-menu {
            .v-menu__content {
                left: 0 !important;
            }
        }

        .v-input {
            height: 56px;
            width: 100%;
        }

        .v-autocomplete__content.v-menu__content {
            position: absolute !important;
        }

        .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
            background: #fff;
        }

        input {
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: 400 !important;
            font-size: 14px !important;
            line-height: 16px !important;
            color: #212529 !important;
        }

        .v-input__slot,
        .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
            background: #fff !important;
            border: 1px solid #ced4da !important;
            border-radius: 0.25rem !important;

            input {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212529 !important;
            }
        }

        .v-text-field>.v-input__control>.v-input__slot {
            &:after {
                content: none !important;
            }

            &:before {
                content: none !important;
            }
        }

        .v-label.v-label--active.theme--light {
            left: -11px !important;
            top: 14px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 11px !important;
            line-height: 13px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            margin-top: 0 !important;
        }

        .v-label.theme--light {
            top: 22px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 11px !important;
            line-height: 13px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            margin-top: 0 !important;
        }
    }

    .floatField_dateInput {
        color: #9598a7;
        font-family: Roboto;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: .1em;
        line-height: 13px;
        margin-top: 0;
        margin-bottom: 0;
        text-transform: uppercase;
        padding: 10px 0 0 17px;
    }

    #klient_nazov::-webkit-contacts-auto-fill-button {
        visibility: hidden;
        display: none !important;
        pointer-events: none;
        position: absolute;
        right: 0;
    }

    .Vue-Toastification__container.top-right {
        z-index: 100000 !important;
    }

    .mx-datepicker-popup {
        z-index: 100000 !important;
    }
</style>
<style lang="scss" scoped>
    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }

        100% {
            transform: scale(1);
        }
    }

    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(0);
        }
    }

    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }

        100% {
            transform: translate(24px, 0);
        }
    }


    .ulozit{
        width: 578px;
        height: 55px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
        margin: 15px auto 0 auto;
        background: #2ED8B6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 23px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #FFFFFF;
        cursor: pointer;
        transition: .5s all;
        &:hover{
            background: #23caa9;
        }
    }

    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');

    .form-floating>label {
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        letter-spacing: 0.05em;
        margin-top: 5px;
        text-transform: uppercase;
        color: #9598A7;
    }

    .form-group {
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }

    * {
        font-family: 'Roboto', sans-serif;
    }

    .form-floating {
        width: 100%;
        margin: 0 auto;
        position: relative;

        .counter {
            position: absolute;
            right: 5px;
            bottom: 5px;
            font-size: 10px;
            font-weight: 300;
            color: #9598A7;
        }
    }

    .modal {
        display: block;
        position: fixed;
        z-index: 1089;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background: rgba(33, 37, 65, 0.89);
        backdrop-filter: blur(5px);

        .modal-content {
            margin: 100px auto 100px auto;
            background: #F7F7F7;
            width: 674px;
            border-radius: 4px;
            box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
            padding-bottom: 50px;

            @media (max-width: 600px) {
                width: 95% !important;
                margin: 50px auto 50px auto;
            }

            .modal-line {
                width: 673px;
                height: 1px;
                background: rgba(215, 60, 120, 0.40);
                transition: opacity .5s;

                &.active {
                    background: #D73C78;
                }

                @media (max-width: 600px) {
                    width: 100% !important;
                }
            }

            .modal-header {
                margin: 35px auto 0 auto;
                width: 578px;
                display: flex;
                align-items: center;
                padding: 0;
                border: none;

                @media (max-width: 600px) {
                    width: 100% !important;
                }

                h1 {
                    width: 427px;
                    height: 34px;
                    text-align: left;
                    font-family: Roboto;
                    font-size: 29px;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                    color: #212541;

                    @media (max-width: 600px) {
                        width: 100% !important;
                    }
                }

                svg {
                    transition: transform .5s;

                    &:hover {
                        cursor: pointer;
                        transform: scale(1.3);
                    }
                }
            }

            .modal-body {
                padding: 0;

                .main {
                    position: relative;
                    width: 578px;
                    margin: 0 auto;
                    border-radius: 4px;
                    background: #FFF;
                    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
                    padding: 20px;
                    margin-top: 22px;

                    .roll_down {
                        position: absolute;
                        right: 20px;
                        top: 35px;
                        cursor: pointer;
                        svg {
                            width: 35px;
                            height: 35px;
                            transition: .5s all;
                            &.active {
                                transform: rotate(180deg);
                            }
                        }
                    }

                    @media only screen and (max-width: 600px) {
                        width: 95%;
                    }

                    h3 {
                        width: auto;
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 21px;
                        color: #212541;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        svg {
                            cursor: pointer;
                            width: 20px;
                            height: 20px;

                            &:hover {
                                transform: scale(1.1);
                            }
                        }
                    }

                    p {
                        width: 85%;
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 16px;
                        color: #9598A7;
                    }

                    .ulozit {
                        width: 474px;

                        @media only screen and (max-width: 600px) {
                            width: 90%;
                        }

                        height: 55px;
                        margin: 37px auto 75px auto;
                        background: #2ED8B6;
                        border-radius: 4px;
                        font-family: 'Roboto',
                        sans-serif;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 16px;
                        line-height: 19px;
                        display: flex;
                        align-items: center;
                        text-align: center;
                        justify-content: center;
                        color: #FFFFFF;
                        cursor: pointer;
                        transition: .5s all;

                        &:hover {
                            background: #23caa9;
                        }
                    }
                }
            }
        }
    }
</style>
